/** Something is happening, and it is worth watching.
 *
 *  This repo has deliberately had no spinner. A cold read shows skeleton rows
 *  (`bits.tsx` `Rows`) and a mutation swaps its button label to "Saving…" —
 *  both say "wait" without a widget, and both are right for the waits they
 *  cover, which are short.
 *
 *  Re-running the lice model is a different wait. It is the only place in the
 *  product where a person presses a button and a model runs: sub-second warm,
 *  but up to five seconds queueing behind another farm's filter and up to
 *  twenty-five if the panel is cold. Long enough that silence reads as broken.
 *
 *  So: six bars, borrowed verbatim from phoniq-insight, where they mean the
 *  same thing on `/demo-blom`. They are an equaliser rather than a spinner
 *  because this company's whole visual language is sound — and because a
 *  rotating arc is a picture of a machine thinking, while bars moving are a
 *  picture of something arriving.
 *
 *  Reduced motion is honoured, not by hiding it, but by holding it still at a
 *  legible height. A person who has asked for less motion still needs to see
 *  that the page is busy.
 */
export function Eq({ bars = 6, label }: { bars?: number; label?: string }) {
  return (
    <span className="eq" role="img" aria-label={label ?? 'Working'}>
      {Array.from({ length: bars }, (_, i) => (
        <span key={i} style={{ ['--i' as string]: i }} />
      ))}
    </span>
  )
}
